import { Fragment, useEffect } from "react";

import { useDrawerStore } from "@/stores/useDrawerStore";

import { useAuth } from "../../context/Auth/AuthProvider";
import { endOfBetaVersionDate } from "../../Pages/Auth/constants";
import { ROUTES, useIsFutureTime, useMediaQueries } from "../../shared";
import CircularLoaderWithBackdrop from "../../shared/components/loaders/CircularLoaderWithBackdrop";
import DesktopDrawer from "../Drawer/DesktopDrawer/DesktopDrawer";
import MobileDrawer from "../Drawer/MobileDrawer/MobileDrawer";
import NavbarHeader from "./components/NavbarHeader/NavbarHeader";
import WelcomeDialog from "./components/WelcomeDialog/WelcomeDialog";

interface NavbarProps {
  route: ROUTES;
}

const Navbar = ({ route }: NavbarProps) => {
  const { isLoading } = useAuth();
  const { isFutureTime } = useIsFutureTime(endOfBetaVersionDate);

  const { fromMd } = useMediaQueries();

  const { isMobileDrawerOpen, setIsMobileDrawerOpen } = useDrawerStore();

  useEffect(() => {
    setIsMobileDrawerOpen(false);
  }, [route, fromMd, setIsMobileDrawerOpen]);

  return (
    <Fragment>
      <NavbarHeader route={route} />

      {fromMd ? (
        <DesktopDrawer />
      ) : (
        <MobileDrawer
          isOpen={isMobileDrawerOpen}
          setIsMobileDrawerOpen={setIsMobileDrawerOpen}
        />
      )}

      {isLoading && <CircularLoaderWithBackdrop isLoading={isLoading} />}

      {isFutureTime && <WelcomeDialog />}
    </Fragment>
  );
};

export default Navbar;
